import { queryClient } from '@/app/providers/queryClient';
import {
  careSearchPatientsQueryDefinition,
  DEFAULT_PATIENT_LIST_LIMIT,
  mapPatientListScopeToDesiredRelationship,
} from '@/entities/care-patients';

/**
 * Dashboard loader — prefetches patient list once onboarding is complete.
 *
 * IMPORTANT: Loaders run before route elements render, so this must never call
 * care endpoints while the user is still mid-onboarding (invite / employee record).
 */
export async function dashboardLoader(): Promise<null> {
  const patientsQuery = careSearchPatientsQueryDefinition({
    query: '',
    limit: DEFAULT_PATIENT_LIST_LIMIT,
    desired_relationship: mapPatientListScopeToDesiredRelationship('default'),
  });
  // Non-blocking prefetch so route rendering is not gated by this request.
  void queryClient.prefetchQuery({
    ...patientsQuery,
    meta: {
      ...patientsQuery.meta,
      toastOnError: false,
    },
  });

  return null;
}
